import {Checkbox} from './Checkbox'
import {Circle} from './Circle'

import {DrillingPosition} from '@refra/modules/refra-planning/types'

interface DrillingSettingsCheckboxesProps {
  radius: number
  labelOffset: number
  centerX: number
  centerY: number
  fields: DrillingPosition[]
}
export const DrillingSettingsCheckboxes = ({
  radius,
  labelOffset,
  centerX,
  centerY,
  fields
}: DrillingSettingsCheckboxesProps) => {
  const calculatePositions = (index: number) => {
    const angleDeg = index * 30
    const angleRad = (-angleDeg * Math.PI) / 180

    const x = centerX + radius * Math.cos(angleRad)
    const y = centerY + radius * Math.sin(angleRad)

    const labelX = centerX + (radius + labelOffset) * Math.cos(angleRad)
    const labelY = centerY + (radius + labelOffset) * Math.sin(angleRad)

    return {
      x,
      y,
      labelX,
      labelY,
      angleDeg: angleDeg.toString()
    }
  }

  return (
    <div
      className={'relative flex justify-center items-center'}
      style={{
        height: `${centerX * 2}px`,
        width: `${centerY * 2}px`
      }}
      data-test-id="drilling_positions_checkbox_container"
    >
      <Circle radius={radius} centerX={centerX} centerY={centerY} />
      {fields.map((_, index) => {
        const {x, y, labelX, labelY, angleDeg} = calculatePositions(index)

        return (
          <div key={index}>
            <Checkbox x={x} y={y} labelX={labelX} labelY={labelY} label={angleDeg} id={index} />
          </div>
        )
      })}
    </div>
  )
}
